import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import CustomizedAccordion from './CustomizedAccordion';
import If from './If';

// What's in the box use box overrides
// Platform
// usbamidi -- UI: A to B connector plus 5pin
// 5pin -- XM
// francis -- EE
// 5pinfrancis -- XMEE
// Modules -- catchall if not platform or midi or expander
// Plugin

export default function ProductAccordion(props: any) {
  const [expanded, setExpanded] = React.useState<string | false>('');

  const pedal = props.productType === 'Pedal';
  const features =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Apparel' &&
    props.productType !== 'Swag' &&
    props.productType !== '5U' &&
    props.productType !== 'Panel' &&
    !props.tags.includes('NE') &&
    !props.tags.includes('Charity') &&
    !props.tags.includes('sale');

  // const smallTechno = props.handle === '3u-techno-machine';
  // const largeTechno = props.handle === '6u-techno-machine';

  const generic =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Apparel' &&
    props.productType !== 'Swag' &&
    props.productType !== '5U' &&
    props.productType !== 'Panel' &&
    props.productType !== 'Legacy Hardware' &&
    props.productType !== 'Pedal' &&
    !props.tags.includes('Platform') &&
    props.box !== 'usbamidi' &&
    props.box !== '5pinfrancis' &&
    props.box !== '5pin' &&
    props.box !== 'francis' &&
    !props.title.includes('VST3') &&
    !props.title.includes('Freequel') &&
    //!smallTechno &&
    //!largeTechno &&

    !props.tags.includes('Charity') &&
    !props.tags.includes('sale');

  const software =
    props.title.includes('VST3') && props.title.includes('Freequel');

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  return (
    <>
      <Stack>
        <If value={features}>
          <CustomizedAccordion
            name='Features and Specs'
            expanded={expanded}
            handleChange={handleChange}
          >
            <div
              className='prod-html'
              dangerouslySetInnerHTML={{ __html: props.featuresandspecs }}
            />
          </CustomizedAccordion>
        </If>
        <If
          value={
            props.tags.includes('Platform') && !props.tags.includes('firmware')
          }
        >
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li> Module</li>
              <li>Power cable</li>
              <li>Micro USB cable</li>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={props.box === 'usbamidi'}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li>Module</li>
              <li>Power cable</li>
              <li>5-pin MIDI to TRS cable</li>
              <li>USB A to B cable</li> <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={props.box === '5pinfrancis'}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li> Module </li>
              <li> Power cable</li>
              <li>5-pin MIDI to TRS cable </li>
              <li>
                3-pin connector cable to attach EE to another module. We call
                this cable Francis.
              </li>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={props.box === 'francis'}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li> Module </li>
              <li> Power cable</li>
              <li>
                3-pin connector cable to attach EE to another module. We call
                this cable Francis.
              </li>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={props.box === '5pin'}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li>Module</li>
              <li>Power cable</li>
              <li>5-pin MIDI to TRS cable</li>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>

        <If value={software}>
          <CustomizedAccordion
            name='System Requirements'
            expanded={expanded}
            handleChange={handleChange}
            width='40%'
          >
            <Typography component='div' align='left' className='prod-html'>
              We support 64-bit only and both Intel and M1 Native (and friends).
              <p></p>
              <li> Windows: Windows 10+</li>
              <li>Mac: MacOS 10.14+ </li>
              <b>Processor Information</b>
              <p></p>
              Our Intel compatible plugins require the SSE4.1 instruction set.
              This was added in the Intel 45nm Penryn architecture in 2007.
              Compatible AMD processors are Bulldozer, Piledriver, Steamroller
              and Ryzen families.<p></p>
              In the Macverse any Mac built after 2010 should have the required
              instructions.<p></p>
              <b>This is a minimum required specification</b>
              <p></p>
              For optimal experience we recommend Intel's Haswell or later and
              AMD's Ryzen family. We also recommend Apple's desktop CPUs (M1 and
              friends).
            </Typography>
          </CustomizedAccordion>
          <CustomizedAccordion
            name='Updates and supported OS'
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              Our plugins come with free updates for the lifetime of the
              product. As long as we make the plugin, it will be supported, and
              if you buy a plugin, it is yours. Updates may include bugfixes or
              feature adds. <br></br>We do not provide access to old versions.
              Our goal is to support operating system versions currently
              supported by Microsoft and Apple.
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={pedal}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li>Pedal</li>
              <li>Quickstart Guide</li>
              <li>Product Sticker</li>
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={generic}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              <li>Module</li>
              <li>Power cable</li>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>
      </Stack>
    </>
  );
}

/*
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              The 3u Techno bundle includes power cables for each module, a
              MicroUSB cable for each platform module, and the following
              products:<br></br>
              <br></br>
              <b>Effects</b>
              <li> Desmodus Versio, platform reverb </li>
              <br></br> <b>Voices</b>
              <li>Incus Iteritas Alia, platform percussion and lead voice</li>
              <li>2x Tymp Legio, platform percussion voice</li>
              <br></br>
              <b>Sequencing</b>
              <li>Mimetic Digitalis, powerful performance sequencer</li>
              <li>Bin Seq, gate sequencer</li>
              <br></br>
              <b>Utility</b>
              <li>Xer Dualis, small mixer</li>
              <li>Horologic Solum, clock source</li>
              <li>Sono Abitus, output module</li>
              <li>
                One complete set of panel overlays for Alia, Legio, and Versio
                platforms{' '}
              </li>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>
        <If value={largeTechno}>
          <CustomizedAccordion
            name="What's in the box?"
            expanded={expanded}
            handleChange={handleChange}
          >
            <Typography component='div' align='left' className='prod-html'>
              The 6u Techno bundle includes power cables for each module, a
              MicroUSB cable for each platform module, and the following
              products: <br></br>
              <br></br>
              <b>Effects</b>
              <li> Desmodus Versio, platform reverb </li>
              <li> Yester Versio, platform delay </li>
              <br></br>
              <b>Voices</b>
              <li>Incus Iteritas Alia, platform percussion and lead voice</li>
              <li>Debel Iteritas Alia, platform percussion and lead voice</li>
              <li>2x Tymp Legio, platform percussion voice</li>
              <li>Loquelic Iteritas Percido, complex voice</li>
              <br></br>
              <b>Sequencing and Modulation</b>
              <li>Mimetic Digitalis, powerful performance CV sequencer</li>
              <li>Numeric Repetitor, algorithmic trigger sequencer</li>
              <li>
                Gamut Repetitor, generative pitch, trigger, and CV sequencer
              </li>
              <li>2x Clep Diaz, versatile CV generator and LFO</li>
              <li>Lapsus Os, quad performance attenuator/controller </li>
              <br></br>
              <b> Processing</b>
              <li>Librae Legio, end-of-chain fx </li>
              <br></br>
              <b>Utility</b>
              <li>Xer Mixa, large stereo performance mixer</li>
              <li>Expando Expandi, CV expander for Xer Mixa</li>
              <li>Horologic Solum, clock source</li>
              <li>Sono Abitus, output module</li>
              <br></br>
              <b>Panel Overlays</b>
              <li>
                One complete set of panel overlays for Alia, Legio, and Versio
                platforms{' '}
              </li>
              <br></br>
              <br></br>
              <i>
                We no longer include screws with newly packaged modules,
                but&nbsp;
                <a href='/products/screws-phillips'>Bulk screws</a> are
                available for purchase.
              </i>
            </Typography>
          </CustomizedAccordion>
        </If>*/
